<section class="header">
  <div class="title">Edit Tab Title</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</section>

<form [formGroup]="tabTitleForm" novalidate autocomplete="off">
  <mat-form-field>
    <mat-label>Title</mat-label>
    <input [formControlName]="'tabTitleControl'" matInput [placeholder]="previousTabTitle" />
    <mat-hint
      *ngIf="
        formControls.tabTitleControl.invalid &&
        (formControls.tabTitleControl.dirty || formControls.tabTitleControl.touched)
      "
    >
      <span *ngIf="formControls.tabTitleControl.errors.maxlength" class="alert-feedback">Title is too long.</span>
    </mat-hint>
  </mat-form-field>

  <!-- Actions -->
  <section class="actions justify-end">
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button tabindex="1" type="button" (click)="discard()">
        <span>Cancel</span>
      </button>
      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        tabindex="0"
        [disabled]="tabTitleForm.pristine || tabTitleForm.invalid"
        (click)="save()"
      >
        <span *ngIf="!tabTitleForm.disabled">Save</span>
        <mat-progress-spinner
          *ngIf="tabTitleForm.disabled"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </div>
  </section>
</form>
